export const resources = {
  Loading: 'Loading'
};
